export const SETTINGS_UPDATE = 'SETTINGS_UPDATE'
export const SETTINGS_UPDATE_RESPONSE = 'SETTINGS_UPDATE_RESPONSE'

export const SETTINGS_DEVLOGS_MARK_AS_READ = 'SETTINGS_DEVLOGS_MARK_AS_READ'
export const SETTINGS_DEVLOGS_MARK_AS_READ_REQUEST = 'SETTINGS_DEVLOGS_MARK_AS_READ_REQUEST'
export const SETTINGS_DEVLOGS_MARK_AS_READ_RESPONSE = 'SETTINGS_DEVLOGS_MARK_AS_READ_RESPONSE'
export const SETTINGS_DEVLOGS_MARK_AS_READ_ERROR = 'SETTINGS_DEVLOGS_MARK_AS_READ_ERROR'

export const SETTINGS_DEVLOGS_UPDATE_LAST_READ = 'SETTINGS_DEVLOGS_UPDATE_LAST_READ'

export const SETTINGS_NOTIFICATION_REMOVE_REQUEST = 'SETTINGS_NOTIFICATION_REMOVE_REQUEST'
export const SETTINGS_NOTIFICATION_TEMPORARY_REMOVE = 'SETTINGS_NOTIFICATION_TEMPORARY_REMOVE'
export const SETTINGS_NOTIFICATION_REMOVE_FROM_CLOSED_LIST =
  'SETTINGS_NOTIFICATION_REMOVE_FROM_CLOSED_LIST'
export const SETTINGS_NOTIFICATIONS_SET = 'SETTINGS_NOTIFICATIONS_SET'

export const SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT = 'SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT'
export const SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT_REQUEST =
  'SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT_REQUEST'
export const SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT_RESPONSE =
  'SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT_RESPONSE'
export const SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT_ERROR =
  'SETTINGS_DEVLOGS_FETCH_POLICY_ENFORCEMENT_ERROR'

export const SETTINGS_UPDATE_CURRENT_USER_ROLE = 'SETTINGS_UPDATE_CURRENT_USER_ROLE'
export const SETTINGS_UPDATE_CURRENT_USER_BILLING_ACCESS =
  'SETTINGS_UPDATE_CURRENT_USER_BILLING_ACCESS'

export const BOT_SETTINGS_FETCH = 'BOT_SETTINGS_FETCH'
export const BOT_SETTINGS_FETCH_REQUEST = 'BOT_SETTINGS_FETCH_REQUEST'
export const BOT_SETTINGS_FETCH_RESPONSE = 'BOT_SETTINGS_FETCH_RESPONSE'
export const BOT_SETTINGS_FETCH_ERROR = 'BOT_SETTINGS_FETCH_ERROR'

// settings: export bot
export const EXPORT_BOT = 'EXPORT_BOT'
export const EXPORT_BOT_REQUEST = 'EXPORT_BOT_REQUEST'
export const EXPORT_BOT_RESPONSE = 'EXPORT_BOT_RESPONSE'
export const EXPORT_BOT_ERROR = 'EXPORT_BOT_ERROR'
export const EXPORT_BOT_COMPLETE = 'EXPORT_BOT_COMPLETE'

// WhatsApp settings
export const UPDATE_WHATSAPP_BUSINESS_SETTINGS = 'UPDATE_WHATSAPP_BUSINESS_SETTINGS'
export const UPDATE_WHATSAPP_BUSINESS_SETTINGS_RESPONSE =
  'UPDATE_WHATSAPP_BUSINESS_SETTINGS_RESPONSE'

// WhatsApp profile photo
export const UPLOAD_WHATSAPP_BUSINESS_AVATAR = 'UPLOAD_WHATSAPP_BUSINESS_AVATAR'
export const UPLOAD_WHATSAPP_BUSINESS_AVATAR_RESPONSE = 'UPLOAD_WHATSAPP_BUSINESS_AVATAR_RESPONSE'
